document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth > 1024) {
        const items = document.querySelectorAll('.products__item-container');

        items.forEach(item => {
            const wrap = item.querySelector('.products__wrap');
            const innerText = item.querySelector('.products__inner-text');

            if (wrap && innerText) {
                const innerTextHeight = innerText.offsetHeight;
                const innerTextMargin = parseFloat(getComputedStyle(innerText).marginBottom) || 0;

                const totalHeight = innerTextHeight + innerTextMargin;

                // Set initial transform
                wrap.style.transform = `translateY(${totalHeight}px)`;

                // Add hover event
                item.addEventListener('mouseenter', () => {
                    wrap.style.transform = 'translateY(0)';
                });

                item.addEventListener('mouseleave', () => {
                    wrap.style.transform = `translateY(${totalHeight}px)`;
                });
            }
        });
    }
});

// let $page = $('html, body');
// $('a[href*="#"]').click(function H() {
//     $('#nav-icon').removeClass('change-icon');
//     $('.js-more-menu').removeClass('active');
//     $('body').removeClass('body-overflow');
//     $page.animate({ scrollTop: $($.attr(this, 'href')).offset().top - $('.page-header').outerHeight() }, 500);
//     return false;
// });

document.querySelectorAll('.menu-item a[href*="#"]').forEach(link => {
    link.addEventListener('click', function (e) {
        const href = this.getAttribute('href');
        if (!href || !href.includes('#')) return;

        const [url, hash] = href.split('#');
        const currentUrl = window.location.pathname.replace(/\/$/, '');
        const linkUrl = url ? new URL(url, window.location.origin).pathname.replace(/\/$/, '') : currentUrl;

        if (linkUrl === currentUrl) {
            // Same page
            const target = document.getElementById(hash);
            if (target) {
                e.preventDefault();
                const header = document.querySelector('.page-header');
                const offset = header ? header.offsetHeight : 0;
                const top = target.getBoundingClientRect().top + window.pageYOffset;
                window.scrollTo({ top, behavior: 'smooth' });
            }
        } else {
            // Different page
            // Let the browser navigate, but add scroll-to-anchor after load
            // Optionally, you can use localStorage/sessionStorage to pass scroll info
        }
    });
});

// Optional: On page load, scroll to anchor if present in URL
window.addEventListener('DOMContentLoaded', function () {
    if (window.location.hash) {
        const id = window.location.hash.substring(1);
        const target = document.getElementById(id);
        if (target) {
            const header = document.querySelector('.page-header');
            const offset = header ? header.offsetHeight : 0;
            const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo({ top, behavior: 'smooth' });
        }
    }
});
